import {
  FilterArea,
  useFilterAreaContentContext,
} from "#src/components/FilterArea";
import { TextInput, type StorageKeys } from "@validereinc/common-components";
import React from "react";
import { z } from "zod";

export const WorkflowConfigurationDrawerAssignmentFilterFilterSchema = z
  .object({
    customAttributeValue: z.string(),
  })
  .partial();
export const WorkflowConfigurationDrawerAssignmentFilterFilterSchemaKeys =
  WorkflowConfigurationDrawerAssignmentFilterFilterSchema.keyof().Enum;
export type WorkflowConfigurationDrawerAssignmentFilterFiltersType = z.infer<
  typeof WorkflowConfigurationDrawerAssignmentFilterFilterSchema
>;

export const WorkflowConfigurationDrawerAssignmentFilterFilterAreaContent = ({
  customAttributeDisplayName,
}: {
  customAttributeDisplayName: string;
}) => {
  const { handleOnChange } = useFilterAreaContentContext();

  return (
    <>
      <TextInput
        name={
          WorkflowConfigurationDrawerAssignmentFilterFilterSchemaKeys.customAttributeValue
        }
        style={{ flexGrow: 1 }}
        placeholder={`Search ${customAttributeDisplayName}...`}
        type="search"
        isInline
        onChange={(val) =>
          handleOnChange(
            val,
            WorkflowConfigurationDrawerAssignmentFilterFilterSchemaKeys.customAttributeValue
          )
        }
      />
    </>
  );
};

export const WorkflowConfigurationDrawerAssignmentFilterFilterArea = ({
  filterConfigStorageKey,
  customAttributeDisplayName,
}: { customAttributeDisplayName: string } & Pick<
  StorageKeys,
  "filterConfigStorageKey"
>) => {
  return (
    <FilterArea.Root
      storageKey={filterConfigStorageKey}
      defaultValues={{
        customAttributeValue: "",
      }}
      applyDefaultValues
    >
      <FilterArea.Container style={{ marginBottom: 8 }}>
        <FilterArea.Content>
          {() => (
            <div
              style={{
                display: "flex",
                gap: 8,
                flexGrow: 1,
              }}
            >
              <WorkflowConfigurationDrawerAssignmentFilterFilterAreaContent
                customAttributeDisplayName={customAttributeDisplayName}
              />
            </div>
          )}
        </FilterArea.Content>
      </FilterArea.Container>
    </FilterArea.Root>
  );
};
